<template>
  <p class="copyright">
    <span>{{ getCopyRight().info.copyRight }}</span>
    <br />
    <span @click="getCopyRight().go2integrated" style="cursor: pointer">{{
      getCopyRight().info.icp
    }}</span>
  </p>
</template>

<script setup>
import { getCopyRight } from '@/utils';
</script>

<style lang="less" scoped>
.copyright {
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  line-height: 28px;
  margin-top: 24px;
}
</style>
